import * as React from "react";
import { forwardRef } from "react";
const SvgClose = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 18 18", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "m8.996 10.056 4.24 4.241a.75.75 0 0 0 1.06-1.06l-4.24-4.241 4.24-4.241a.75.75 0 0 0-1.06-1.06l-4.24 4.24-4.24-4.24a.75.75 0 0 0-1.06 1.06l4.24 4.24-4.24 4.242a.75.75 0 1 0 1.06 1.06z", fill: "currentColor", fillOpacity: 0.8 }));
const ForwardRef = forwardRef(SvgClose);
export default ForwardRef;
